import { lazy } from "react"

const ContributionOverviewPage$$__react__lazy__component = lazy(() => 
    import("./ContributionOverviewPage__original__module.mjs")
        .then(module => module.get_$$ContributionOverviewPage$$ContributionOverviewPage$$react__component$$2atql5kjreqrf())
        .then(component => ({ default: component }))
)

export const get_$$ContributionOverviewPage$$ContributionOverviewPage$$react__component$$2atql5kjreqrf = () => ContributionOverviewPage$$__react__lazy__component